module.exports = __webpack_public_path__ + "static/img/17.82fcf7f6.png";